import React from "react";


const ImageBox = ({ src, remove, ali }) => {
  if (src) {
    return (
      <div className="col-6  col-md-5 padding-10">
        <div className="form5-sm-box">
          <img src={src} className="rgc-img" alt="" />
          <div>{ali}</div>
          <div className="delete-file" onClick={() => remove()}>
            حذف فایل <i className="fa fa-times-circle fa-fw"></i>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="col-6  col-md-5  padding-10">
        <div className="form5-sm-box empty-spot">
          <i className="fa fa-camera" style={{color:"#6e68f7"}}></i>
          <i className="icon icon-image-empty-spot"></i>
        </div>
      </div>
    );
  }
};

export default ImageBox;
